export const INITIAL_REPORTS_SEARCH_PARAMS = {
  page: 1,
  id: '',
  name: '',
  internal: '',
  external: '',
  sort_method: 'desc',
  order_by: 'report_type_id',
  limit: 300,
}

export const INITIAL_REPORT = {
  id: null,
  name: '',
  description: '',
}

export const REPORT_STATUS = {
  ACTIVE: 1,
  INACTIVE: 0,
}

export const INITIAL_REPORT_EDIT = {
  id: null,
  name: '',
  description: '',
  report_type_id: '',
  report_status_id: REPORT_STATUS.ACTIVE,
  is_bridge: false,
  is_prox: false,
  is_external: false,
}

export const INITIAL_REPORT_EXPORT = {
  client_id: '',
  warehouse_id: '',
  language_id: '',
  report_type: '',
  view_mode: '',
  start_date: '',
  end_date: '',
  is_client: '',
  is_grouped: '',
  sku: '',
  date: '',
}

export const TRANSPORT_REPORT_TYPES = {
  TRANSPORT: 1,
  DUTY: 2,
}

export const TRANSPORT_REPORT_TYPE_NAMES = {
  TRANSPORT: 'Transport',
  DUTY: 'Duty',
}

export const SUPPLY_USAGE_REPORT_TYPES = {
  DETAIL: 1,
  SUMMARY: 2,
}

export const SUPPLY_USAGE_REPORT_TYPE_NAMES = {
  DETAIL: 'Detail',
  SUMMARY: 'Summary',
}

export const REPORT_IS_CLIENT = {
  INTERNAL: 0,
  CLIENT: 1,
}

export const REPORT_IS_CLIENT_NAMES = {
  INTERNAL: 'Internal',
  CLIENT: 'Client',
}

export const REPORT_IS_GROUPED = {
  YES: 1,
  NO: 0,
}

export const REPORT_IS_GROUPED_NAMES = {
  YES: 'Yes',
  NO: 'No',
}

export const REPORTS_CONFIG = {
  TRANSPORT: {
    code: 1,
    name: 'transport',
    hasView: false,
    hasExport: true,
    hasModal: true,
    isPowerBi: false,
  },
  REBILLING_RECONCILIATION: {
    code: 2,
    name: 'rebilling-reconciliation',
    hasView: false,
    hasExport: true,
    hasModal: true,
    isPowerBi: false,
  },
  INVENTORY_TRACKER: {
    code: 3,
    name: 'inventory-tracker',
    hasView: true,
    hasExport: false,
    hasModal: false,
    isPowerBi: true,
  },
  ORDER_SHIPMENT: {
    code: 4,
    name: 'order-shipment',
    hasView: true,
    hasExport: false,
    hasModal: false,
    isPowerBi: true,
  },
  SUPPLY_USAGE: {
    code: 5,
    name: 'supply-usage',
    hasView: false,
    hasExport: true,
    hasModal: true,
    isPowerBi: false,
  },
  WAREHOUSE_STORAGE: {
    code: 6,
    name: 'warehouse-storage',
    hasView: false,
    hasExport: true,
    hasModal: true,
    isPowerBi: false,
  },
  QUOTE_BILL_ANALYSIS: {
    code: 7,
    name: 'quote-bill-analysis',
    hasView: true,
    hasExport: false,
    hasModal: false,
    isPowerBi: true,
  },
  PICK_PRIORITY: {
    code: 8,
    name: 'pick-priority',
    hasView: true,
    hasExport: false,
    hasModal: false,
    isPowerBi: true,
  },
  INVENTORY_INSIGHT: {
    code: 9,
    name: 'inventory-insight',
    hasView: false,
    hasExport: true,
    hasModal: true,
    isPowerBi: false,
  },
  RECEIVING: {
    code: 10,
    name: 'receiving',
    hasView: false,
    hasExport: true,
    hasModal: true,
    isPowerBi: false,
  },
  ORDER_PICKING: {
    code: 11,
    name: 'order-picking',
    hasView: false,
    hasExport: true,
    hasModal: true,
    isPowerBi: false,
  },
  RETURN: {
    code: 12,
    name: 'return',
    hasView: false,
    hasExport: true,
    hasModal: true,
    isPowerBi: false,
  },
  FREIGHT: {
    code: 13,
    name: 'freight',
    hasView: false,
    hasExport: true,
    hasModal: true,
    isPowerBi: false,
  },
  SHIPPING_COST: {
    code: 14,
    name: 'shipping-cost',
    hasView: false,
    hasExport: true,
    hasModal: true,
    isPowerBi: false,
  },
  INVENTORY_BY_LOCATION: {
    code: 15,
    name: 'inventory-by-location',
    hasView: false,
    hasExport: true,
    hasModal: true,
    isPowerBi: false,
  },
  INVENTORY_AS_OF: {
    code: 16,
    name: 'inventory-as-of',
    hasView: false,
    hasExport: true,
    hasModal: true,
    isPowerBi: false,
  },
}

export const REPORT_CODES = Object.keys(REPORTS_CONFIG).reduce((acc, key) => {
  acc[key] = REPORTS_CONFIG[key].code
  return acc
}, {})

export const REPORT_VIEW = Object.keys(REPORTS_CONFIG).reduce((acc, key) => {
  acc[REPORTS_CONFIG[key].code] = REPORTS_CONFIG[key].hasView
  return acc
}, {})

export const REPORT_EXPORT = Object.keys(REPORTS_CONFIG).reduce((acc, key) => {
  acc[REPORTS_CONFIG[key].code] = REPORTS_CONFIG[key].hasExport
  return acc
}, {})

export const REPORT_CONFIG_BY_ID = Object.keys(REPORTS_CONFIG).reduce((acc, key) => {
  acc[REPORTS_CONFIG[key].code] = REPORTS_CONFIG[key]
  return acc
}, {})

export const REPORT_POWER_BI = Object.keys(REPORTS_CONFIG).reduce((acc, key) => {
  acc[REPORTS_CONFIG[key].code] = REPORTS_CONFIG[key].isPowerBi
  return acc
}, {})
